import { ref } from 'vue';
import { translate } from '@elements/translations';

const currentStep = ref('WithdrawalForm');
const identification = ref({ firstname: '', lastname: '', orderNr: '', email: '' });
const positions = ref([]);
const reasons = ref([]);
const currency = ref(null);
const selection = ref({});
const selectedReasons = ref({});
const result = ref(null);
const noticeError = ref(null);
const fieldErrors = ref({});
const loading = ref(false);

export function useWithdrawalState() {
    function reset() {
        noticeError.value = null;
        fieldErrors.value = {};
    }

    async function post(url, payload) {
        loading.value = true;
        reset();
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const data = await response.json();
            if (data.fieldErrors) {
                fieldErrors.value = data.fieldErrors;
                return null;
            }
            if (data.error) {
                // already translated server-side (Symfony translator) - render as-is
                noticeError.value = data.error;
                return null;
            }
            return data;
        } catch (e) {
            // network/parse failure - the server never got a chance to translate anything,
            // so this is the one notice-level message the frontend supplies itself
            noticeError.value = translate('withdrawal.error.network');
            return null;
        } finally {
            loading.value = false;
        }
    }

    return {
        currentStep,
        identification,
        positions,
        reasons,
        currency,
        selection,
        selectedReasons,
        result,
        noticeError,
        fieldErrors,
        loading,
        post,
        reset,
    };
}
